import { createDateOnlyFromDate, type DateOnly } from '@talos/kyoko';
import { SIGNALS_TIME_RANGE_LIMIT, type SignalsTimeRange } from '../core/tokens';

export interface ComparisonDateRange {
  startDate: DateOnly;
  endDate: DateOnly;
}

/** Computes start and end DateOnly values for a quick-set time range, relative to today. */
export function computeDateRangeForTimeRange(range: SignalsTimeRange): ComparisonDateRange {
  const today = new Date();
  const endDate = createDateOnlyFromDate(today);
  const limitDays = SIGNALS_TIME_RANGE_LIMIT[range];

  if (limitDays === null) {
    // 'All' — earliest reliable daily data in CoinMetrics
    return { startDate: '2010-01-01' as DateOnly, endDate };
  }

  const start = new Date(today);
  start.setDate(start.getDate() - limitDays);
  return { startDate: createDateOnlyFromDate(start), endDate };
}
